module.exports = __webpack_public_path__ + "img/14.88146c13.svg";